/**
 * Порог шума для изменений — КОПИЯ СЕРВЕРНОГО `rk/trend.ts`.
 *
 * Общего модуля у сервиса и кабинета нет: `web/` — отдельный пакет.
 * Значит копия неизбежна, и защита может быть только одна — проверка,
 * читающая оба исходника и требующая, чтобы числа совпадали. Она лежит
 * в `trend-view.spec.ts`.
 *
 * ПОЧЕМУ ЭТО ВАЖНО. Разойдись пороги — и сервер посчитал бы изменение
 * заметным, а кабинет не показал бы его вовсе. Молчание вместо новости
 * не выглядит поломкой и потому не чинится.
 */
export const NOISE_PCT = 5;

export function isNoise(pct: number | null): boolean {
  return pct === null || Math.abs(pct) < NOISE_PCT;
}
